import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { Stack, Typography } from '@mui/material';

import Logger from 'browser-logging/src/browser/Logger';

export default function Error() {
  const error: any = useRouteError();

  useEffect(() => {
    Logger.captureError(error);
  }, [error]);

  return (
    <Stack alignItems="center" justifyContent="center" height="100vh">
      <Typography variant="h3">{error?.status ?? 'OOPS!'}</Typography>
      <Typography variant="body1">
        {error?.statusText ??
          'Sorry, We are having some technical issues. Try again later.'}
      </Typography>
    </Stack>
  );
}
